import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable()
export class ToolkitBackend {
  private readonly http = inject(HttpClient);

  searchPlaces(query: string): Observable<{
    candidates: Array<{ place_id: string }>;
    status: "INVALID_REQUEST";
  }> {
    return this.http.get<{ candidates: any[]; status: "INVALID_REQUEST" }>(
      `${environment.snoots.toolkit.endpoint}/places`,
      {
        params: {
          input: query,
          inputtype: "textquery",
          language: "it"
        }
      }
    );
  }

  getPlaceDetails(placeId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.snoots.toolkit.endpoint}/places/${placeId}`,
      {
        params: {
          language: "it"
        }
      }
    );
  }
}
